<template>
  <div class="yk-stu-manager-new-wrapper clearfix">
    <el-form
      label-width="180px"
      :rules="rules"
      ref="form"
      :model="form"
      class="change-user-password-form"
    >
      <el-form-item label="考试标题" prop="ExamTitle">
        <el-input v-model="form.ExamTitle"></el-input>
      </el-form-item>
      <el-form-item label="考试时间安排" prop="ExamTimeUrl">
        <imageUpload :url="urlAliyunOSS" :files.sync="form.ExamTimeUrl" format="image"></imageUpload>
      </el-form-item>
     
      <el-form-item>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      form: {
        Id: "",
        ExamTitle: "",
        ExamTimeUrl: ""
      },
      rules: {
        ExamTitle: [{ required: true, message: "请输入", trigger: "blur" }],
        ExamTimeUrl: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.getFileUrlList();
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var that = this;
          that.$http
            .post("/api/XOrg/FileManager/addOrEditExamInfo", {
              Id: that.form.Id,
              ExamTitle: that.form.ExamTitle,
              ExamTimeUrl: that.form.ExamTimeUrl,
              certificateId:this.certificateId
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getFileUrlList();
                that.$message.success(rst.msg);
              } else {
                that.$message.warning(rst.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //查询
    getFileUrlList() {
      var that = this;
      this.$http
        .post("/api/XOrg/FileManager/getFileUrlList",{
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.form = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.yk-stu-manager-new-wrapper {
  padding-top: 50px;
  .change-user-password-form {
    width: 50%;
  }
}
</style>